import React, { useEffect, useState } from 'react';
import {biblequotes} from '../../utils/biblequotes.js'; 

const BibleVerses = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fadeClass, setFadeClass] = useState('opacity-100');
  const [isTransitioning, setIsTransitioning] = useState(false);

  const getRandomIndex = () => {
    let newIndex;
    do {
      newIndex = Math.floor(Math.random() * biblequotes.length);
    } while (newIndex === currentIndex && biblequotes.length > 1);
    return newIndex;
  };

  const changeVerse = (newIndex) => {
    if (isTransitioning) return;
    
    setIsTransitioning(true);
    setFadeClass('opacity-0');
    
    setTimeout(() => {
      setCurrentIndex(newIndex);
      setFadeClass('opacity-100');
      setTimeout(() => setIsTransitioning(false), 300);
    }, 300);
  };

  const getNewRandomVerse = () => {
    changeVerse(getRandomIndex());
  };

  useEffect(() => {
    const interval = setInterval(() => {
      changeVerse(getRandomIndex());
    }, 8000);

    return () => clearInterval(interval);
  }, [currentIndex]);

  const { verse, text } = biblequotes[currentIndex];

  return (
    <div className="w-full max-w-lg mx-auto">
      {/* Decorative elements */}
      <div className="relative">
        <div className="absolute -top-2 -left-2 text-3xl text-white/20 font-serif leading-none">"</div>
        <div className="absolute -bottom-2 -right-2 text-3xl text-white/20 font-serif leading-none">"</div>
        
        {/* Main verse container */}
        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20 shadow-xl">
          <div className={`transition-all duration-300 ${fadeClass}`}>
            <p className="text-white/90 text-sm leading-relaxed mb-4 font-light tracking-wide text-center italic">
              {text}
            </p>
            
            {/* Elegant divider */}
            <div className="flex items-center justify-center my-4">
              <div className="h-px bg-white/30 flex-1"></div>
              <div className="mx-3">
                <div className="w-1.5 h-1.5 bg-white/40 rounded-full"></div>
              </div>
              <div className="h-px bg-white/30 flex-1"></div>
            </div>
            
            <p className="text-blue-100 text-xs text-center font-medium tracking-widest uppercase">
              {verse}
            </p>
          </div>
        </div>

        {/* Controls */}
        <div className="flex items-center justify-center mt-4 space-x-3">
          <button
            onClick={getNewRandomVerse}
            disabled={isTransitioning}
            className="group bg-white/10 backdrop-blur-sm border border-white/20 rounded-full p-2 hover:bg-white/20 transition-all duration-200 hover:scale-105 disabled:opacity-50 disabled:hover:scale-100"
            aria-label="Get new verse"
          >
            {/* <RefreshCw className={`w-3.5 h-3.5 text-white/80 group-hover:text-white transition-all duration-200 ${isTransitioning ? 'animate-spin' : ''}`} /> */}
          </button>

          {/* Progress dots */}
          <div className="flex space-x-1">
            {[...Array(3)].map((_, index) => (
              <div
                key={index}
                className={`w-1.5 h-1.5 rounded-full transition-all duration-300 ${
                  index === currentIndex % 3 
                    ? 'bg-white/60 scale-125' 
                    : 'bg-white/20'
                }`}
              />
            ))}
          </div>
        </div>

        {/* Inspirational footer */}
        <div className="text-center mt-4">
          <p className="text-white/50 text-xs font-light tracking-wide">
            Daily Inspiration
          </p>
        </div>
      </div>
    </div>
  );
};

export default BibleVerses;